import { apiClient } from './apiClient';
import { Language } from '../types/language';

export const userService = {
  // Получить язык пользователя
  getUserLanguage: async (): Promise<Language> => {
    const response = await apiClient.get('/user/language');
    return response.data;
  },

  // Обновить язык пользователя
  updateUserLanguage: async (language: Language): Promise<void> => {
    await apiClient.put('/user/language', { language });
  }
};
